import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { instance } from "@/lib/axios/instance";

type RegisterCompanyRequest = {
  companyName: string;
  city: string;
  description: string;
  contactName: string;
  contactEmail: string;
  tenantId: string;
  clientId?: string;
  companyPhone?: string;
  websiteUrl?: string;
  companyType?: string;
  contactPhone?: string;
};

type RegisterCompanyResponse = {
  companyId: string;
  companyName: string;
};

export const registerCompanyAtVacaturesOnline = async (
  integrationName: string,
  request: RegisterCompanyRequest
): Promise<RegisterCompanyResponse> => {
  const response = await instance.post<RegisterCompanyResponse>(
    `/api/v2/Integrations/${encodeURIComponent(integrationName)}/RegisterCompany`,
    request
  );
  return response.data;
};

export function useRegisterCompany(integrationName: string) {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (request: RegisterCompanyRequest) =>
      registerCompanyAtVacaturesOnline(integrationName, request),
    onError: () => {
      toast.error(
        t(
          "integrations.registerCompany.error",
          "Failed to register company. Please check the details and try again."
        )
      );
    },
  });
}
